module.exports = __webpack_public_path__ + "static/media/customer-complaint-empty.d7242231.svg";